export const PRIMARY_COLOR = '#02B875';
export const SHARE_IMAGE_URL = '/img/logo/logos_doctrine/banner_fr.png';
export const WEBSITE_URL = 'https://www.doctrine.fr';
